import { render, staticRenderFns } from "./ProductRequests.vue?vue&type=template&id=32e2bd2e&scoped=true"
import script from "./ProductRequests.vue?vue&type=script&lang=js"
export * from "./ProductRequests.vue?vue&type=script&lang=js"
import style0 from "./ProductRequests.vue?vue&type=style&index=0&id=32e2bd2e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32e2bd2e",
  null
  
)

export default component.exports